import React from 'react'
import './Services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I offer</h5>
      <h2>Services</h2>

      <div className="container services_container">
        <article className="service">
          <div className="service_head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <p>Designing Various Animations</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Promotional and Informative Posts</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Videos and Photo Editing</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Memes, Cards, etc</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service_head">
            <h3>Web Development</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <p>Portfolio Websites</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Admin and HRMS</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Education and NGOs</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Corporate and Industrial</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Online Buisness and E-Commerce, etc</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service_head">
            <h3>Content Creation</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <p>Hindi and English Content Writing</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Technical and Non Tech topics</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Stories and Newsletters</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Books, Copywrite, etc</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service_head">
            <h3>Tour and Explore</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <p>Heritage and Spritual Walks</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Jungle Echo Tours</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Trekking and Hiking</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Outstation Free Guided Tours</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>International Travel Packages</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service_head">
            <h3>Data Analyst</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <p>Data Analysis and Visualization</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Buisness Analysis</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Marketing Strategies</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Consumer Behaviour Analysis</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Data Cleaning</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service_head">
            <h3>Machine Learning and AI</h3>
          </div>

          <ul className="service_list">
            <li>
              <BiCheck className='service_list-icon'/>
              <p>Online One to One Teaching</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Classification Models</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Predictive Models</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Transfer Learning</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Robotics and Automation</p>
            </li>

            <li>
              <BiCheck className='service_list-icon'/>
              <p>Chat Bots</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services